export const customStyles = {
	indicatorContainer: (provided) => ({
		...provided,
		padding: "5px",
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		padding: "2px",
	}),
	control: (base) => ({
		...base,
	}),
	menuPortal: (base) => ({
		...base,
		zIndex: 9999,
	}),
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? "#e8f5e8" : provided.backgroundColor,
		"&:hover": {
			backgroundColor: state.isSelected ? "#d4edd4" : "#f0f0f0",
		},
	}),
};

export const customSelectProductStyles = {
	indicatorContainer: (provided) => ({
		...provided,
		padding: "5px",
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		padding: "2px",
	}),
	control: (base, state) => ({
		...base,
		width: state.isFocused ? "450px" : "100%",
		minWidth: state.isFocused ? "450px" : "auto",
		transition: "width 0.5s ease-in-out",
	}),
	menuPortal: (base) => ({
		...base,
		zIndex: 9999,
	}),
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? "#e8f5e8" : provided.backgroundColor,
		"&:hover": {
			backgroundColor: state.isSelected ? "#d4edd4" : "#f0f0f0",
		},
	}),
};

export const customInputStyle = { fontSize: "12px" };

export const customStyleForColumns = {
	option: (provided) => ({
		...provided,
		fontSize: "10px",
		padding: 8,
	}),
	control: (provided) => ({
		...provided,
		fontSize: "10px",
	}),
};

export const customSelectorStyle = {
	control: (provided) => ({
		...provided,
		textAlign: "left",
	}),
	menu: (provided) => ({
		...provided,
		textAlign: "left",
	}),
	option: (provided) => ({
		...provided,
		textAlign: "left",
	}),
};
